import Layout from '@/features/reservation/components/Layout';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import { eAgreeState } from '../type/contract';

type InfoTradingAgreementProps = {
  nextTrans: () => void;
  facilityName: string | '';
  termsAndConditions: string | '';
  fileName: string | '';
  filePath: string | '';
  returnInstructions: string | '';
  feeDescription: string | '';
  contractJudgeInfo: eAgreeState;
  setContractJudgeInfo: (state: number) => void;
};

// 情報返却・取引同意
export const InfoTradingAgreement = (props: InfoTradingAgreementProps) => {
  // 同意選択時の処理
  function AgreementHandler(status: eAgreeState) {
    props.setContractJudgeInfo(status);
    props.nextTrans();
  }
  // すでに同意済みなら表示しない
  if (props.contractJudgeInfo === eAgreeState.agree) {
    props.nextTrans();
  }

  console.log(props.filePath);

  // ダイアログステータス
  const [open, setOpen] = useState<boolean>(false);
  // 確認ダイアログを閉じる
  const dialogClose = () => {
    setOpen(false);
  };
  // 確認ダイアログを開く
  const dialogOpen = () => {
    setOpen(true);
  };

  return (
    <Layout title={props.facilityName}>
      <Box sx={{ margin: 'auto', px: 3, pt: 6 }}>
        <Typography className="text-lg text-center font-bold">情報返却・取引同意</Typography>
      </Box>
      <Box sx={{ margin: 'auto', px: 3, py: 1 }}>
        <Typography className="text-base pt-6 text-left">
          あなたに医療情報(問診やレントゲン)をお返しいたします。
        </Typography>
        <Paper elevation={0} className="p-5 text-sm leading-normal">
          {props.returnInstructions.split('\\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Paper>
      </Box>
      <Box sx={{ margin: 'auto', px: 3, py: 1 }}>
        <Typography className="text-base text-left">報酬を受け取る際に手数料が発生いたします。</Typography>
        <Paper elevation={0} className="p-5 text-sm leading-normal">
          {props.feeDescription.split('\\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Paper>
      </Box>
      {/* <Box sx={{ margin: 'auto', px: 3, py: 1 }}>
        <Typography className="text-base text-left">利用規約</Typography>
        <Paper elevation={0} className="p-5 max-h-80 overflow-y-auto">
          <Typography className="text-sm text-left leading-normal">
            {props.termsAndConditions.split('\\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </Typography>
        </Paper>
      </Box> */}
      <Box sx={{ margin: 'auto', px: 3, pb: 2 }}>
        {/* <Link href={props.filePath} download={props.fileName}>
          <Typography className="py-3 text-sm text-right text-current">ダウンロード（PDF）</Typography>
        </Link> */}
        <Button
          className="w-full h-auto my-2 py-3 bg-primary text-white text-lg font-semibold"
          onClick={() => {
            AgreementHandler(eAgreeState.agree);
          }}
        >
          同意して次へ進む
        </Button>
        <Button
          className="w-full h-auto my-2 py-3 border-solid border-2 border-primary bg-transparent text-primary text-lg font-semibold"
          onClick={dialogOpen}
        >
          同意しない
        </Button>
      </Box>
      <Dialog
        onClose={dialogClose}
        open={open}
        disableAutoFocus // Popoverが表示される際にフォーカスを自動的に取得しないようにする
        disableEnforceFocus // フォーカスの強制を無効にする
      >
        <IconButton
          onClick={dialogClose}
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8
          }}
        >
          <Close />
        </IconButton>
        <DialogTitle className="w-full pt-8 pb-4 text-center font-semibold text-base">
          本当に同意しないで
          <br />
          よろしいでしょうか？
        </DialogTitle>
        <DialogContent className="w-full px-auto">
          <Button
            className="w-full h-auto mx-auto my-2 mx-2 py-3 px-14 bg-primary text-white text-base font-semibold"
            onClick={() => {
              AgreementHandler(eAgreeState.notAgree);
            }}
          >
            同意しない
          </Button>
          <Button
            className="w-full h-auto mx-auto my-2 mx-2 py-3 px-5 border-solid border-2 border-red-600 bg-transparent text-red-600 text-base font-semibold"
            onClick={dialogClose}
          >
            キャンセル
          </Button>
        </DialogContent>
      </Dialog>
    </Layout>
  );
};

export default InfoTradingAgreement;
